module.exports = __webpack_public_path__ + "img/no-photo-placeholder.6db24fed.png";